import { useTheme } from 'styled-components';

export const ArrowIconV2: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_16722_4223)">
        <path
          d="M20 12.0001L18.59 10.5901L13 16.1701L13 4.00006H11L11 16.1701L5.42 10.5801L4 12.0001L12 20.0001L20 12.0001Z"
          fill={theme.softGrey}
        />
      </g>
      <defs>
        <clipPath id="clip0_16722_4223">
          <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 -1 24 24)" />
        </clipPath>
      </defs>
    </svg>
  );
};
